import { Chip, ChipProps } from "../../../../components/base/informational/Chip"
export interface ActiveChipProps extends Omit<ChipProps, "color" | "text"> {
  isActive: boolean
}

export function ActiveChip({ isActive, ...otherProps }: ActiveChipProps) {
  if (isActive) {
    return <Chip color="green" text="Active" {...otherProps} />
  }

  return <Chip color="red" text="Inactive" {...otherProps} />
}
